import { render, staticRenderFns } from "./HeaderUtilityTopMenuItem.vue?vue&type=template&id=6c136e74&"
import script from "./HeaderUtilityTopMenuItem.vue?vue&type=script&lang=js&"
export * from "./HeaderUtilityTopMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports